import { ConsultationSource } from "./ConsultationSource";

export interface ConsultationAuteur {
    autre?: string;
    id?: string;
}

export const AUTEUR_AUTRE = 'Autre auteur';

export interface Consultation {
    id?: string;
    idPatient: string;
    idProfil?: string;
    date: Date;
    titre: string;
    typeConsultation?: string;
    statut?: "actif" | "inactif" | "resolu";
    idGroupe?: string;
    private?: boolean;
    creationDate?: Date;
    modificationDate?: Date;
    disabled?: boolean;
    consultationSource?: ConsultationSource;
    auteur: ConsultationAuteur;
}